<h2 mat-dialog-title class="focal-title">Adjust focal point</h2>

<mat-dialog-content class="focal-content">
  <p class="focal-hint">
    Click or drag on the image to choose the part that must stay in frame — usually the
    artist's face. Arrow keys nudge by 1%, hold Shift for 10%.
  </p>

  <div class="focal-panes">
    <!-- Source: whole image visible, crosshair placed on it -->
    <div class="focal-pane">
      <span class="focal-pane-label">Full image</span>

      <div #sourceSurface
           class="focal-surface"
           tabindex="0"
           role="application"
           aria-label="Focal point picker. Use the arrow keys to move the focal point."
           (mousedown)="onMouseDown($event)"
           (mousemove)="onMouseMove($event)"
           (mouseup)="endDrag()"
           (mouseleave)="endDrag()"
           (touchstart)="onTouchStart($event)"
           (touchmove)="onTouchMove($event)"
           (touchend)="endDrag()"
           (keydown)="onKeyDown($event)">
        <img [src]="imageUrl" alt="" class="focal-source-image" draggable="false" />

        <div class="focal-crosshair"
             [style.left.%]="focalX"
             [style.top.%]="focalY"
             aria-hidden="true">
          <span class="focal-crosshair-ring"></span>
        </div>
      </div>
    </div>

    <!-- Preview: the actual tile crop, driven by the same helper the grid uses -->
    <div class="focal-pane">
      <span class="focal-pane-label">Tile preview</span>

      <div class="focal-preview">
        <img [src]="imageUrl"
             alt=""
             class="focal-preview-image"
             [style.object-position]="previewPosition"
             draggable="false" />
      </div>

      <span class="focal-readout">{{ readout }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="focal-actions">
  <button mat-button type="button" (click)="recenter()">Re-centre</button>
  <span class="focal-actions-spacer"></span>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="save()">Save</button>
</mat-dialog-actions>
